module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-2-4"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("When I awoke the next morning, my soreness had improved from the soaking. I was feeling anxious about opening the shop again. I got dressed earlier than usual because the workman would be arriving with the new windows. I couldn’t wait to take my coffee to one of the porches, like I frequently did on the second-floor porch at my flat on The Hill when I lived there. When I opened the shop, I placed Rosie’s rocking chair on the front porch as I had done since the day I opened. It was the perfect prop to display a quilt. My phone rang, taking me away from my job of arranging the quilt artistically across the arm of the rocker. It was Holly.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“How are you, girlfriend?” she asked cheerfully.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m well. I had a good soak last night with some oils that Laurie sent, and I think it helped.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Wonderful! I’m calling to ask if I could borrow a couple of quilts from you again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Sure, what do you need?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m doing a talk on hexagons, or hexies as they say now. Do you still have that Grandmother’s Flower Garden quilt?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, I think so. It’s on the rack for sale.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I think you also had a wool Flower Garden quilt that was tied. It might have been from Rosie’s inventory. I’ll borrow that as well if you still have it.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I had to think for a moment. “Okay, but are you going to come out and get them? I have no plans to come to The Hill until Thanksgiving when I go to Lynn’s house.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Bummer. Well, I’ll try to get out there tomorrow. I’ll think of something to tell the monster.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("The monster was Holly’s abusive husband, Maurice. Why she continued to put up with him was a mystery to me. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“How is he feeling?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Not well. You should see how thin he’s getting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Has he told you what’s wrong?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“No, and I’ve given up. He gets so angry when I ask.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Well, you need to go on and live your life if he doesn’t want help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, he wants my help, but it’s all the domestic duties that he wouldn’t touch with a ten-foot pole.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Whatever,” I replied, hoping to not sound callous. I had given up on giving Holly advice quite some time ago. “Should I make lunch for us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Why don’t I just pick up lunch from a deli like I’ve done in the past?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, that would be wonderful! Thanks!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I hung up feeling frustrated. Hearing about her difficult life circumstances always made me feel ill at ease. I wondered what kind of ending her situation could possibly have. Holly had so much to offer, but her restricted life left her unable to enjoy the wealth that she and Maurice had acquired. We were friends forever, but sometimes the relationship was difficult to navigate. How would I feel if something bad happened to her? How much should a friend interfere with their friend’s bad choices?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I had my first customers around noon. The two elderly ladies were both in good moods and seemed to be delighted when they saw my cute little shop.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You have a lot of commotion going on here,” the lady wearing a red hat said.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m sorry for the hammering noise, but I’m having some new windows put in today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Are you Ms. Rosenthal?” the other lady asked as she removed her coat.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, I am,” I answered as I tried to keep my eye on red hat lady.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I have some things to sell, and I heard you may be interested in buying them,” she said as her eyes took in the contents of the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“What are you selling?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Well, I live in a farmhouse near the Boone home and I’m moving in with my son. I need to sell almost everything. I have mostly antiques.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Have you considered having an estate sale?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I may have to, but right now, I’m trying to sell some things myself,” she explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“If she can sell something sooner, then she gets the money,” red hat lady interrupted. “If she sells it at a sale, her son will take it all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, I see. Well then, write down your contact information and I’ll see what I can do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, that would be wonderful!” she responded. “I want to look around at some of your prices on the quilts and things, if you don’t mind. I have no idea what some of my things are worth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Thanks for your honesty, but I hope you realize that these prices wouldn’t be what you’d receive,” I explained. “I have to purchase them low enough to mark them up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, I understand.” She nodded. “I see you have a lot of quilts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Do you have quilts?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I sure do! Nice ones, too, if I do say so myself. I sure hate to let them go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Well, surely you will keep some for yourself.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“If my son will let me,” she responded as she shook her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“He won’t let her if he thinks he can get a few bucks for them,” her friend added bitterly. “Agnes has a few red-and-white quilts, don’t you? I see you have a lot of them here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, I have one called Broken Dishes and a really nice Turkey Tracks pattern,” Agnes recalled.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“They sound very appealing. I don’t have either one of those patterns,” I said, becoming interested. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-108a863d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Lily_Girl_split7.vue
// module id = 81
// module chunks = 0